module.exports = __webpack_public_path__ + "img/teams.d61d8b9c.png";